import { Component } from 'react';
import classnames from 'classnames';
import { withStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import APCheckboxStyles from './styles/APCheckbox.style';

class APCheckbox extends Component<any, {}> {
  render() {
    const {
      classes,
      label,
      name,
      onChange,
      value = false
    } = this.props;

    return (
      <FormControlLabel
        className={`checkBoxGroup ${classnames(classes.checkboxControl, { [name]: name })}`}
        control={
          <Checkbox
            checked={value}
            color="primary"
            onChange={onChange}
            name={name}
          />
        }
        label={label}
      />
    );
  }
}

export default withStyles(APCheckboxStyles)(APCheckbox);
